import { apiErrorSchema } from '@lyra/shared';

/** Thrown for any non-2xx response; carries the HTTP status and the server's
 *  Romanian `{ error }` message (or a generic fallback). */
export class ApiClientError extends Error {
  readonly status: number;
  constructor(status: number, message: string) {
    super(message);
    this.name = 'ApiClientError';
    this.status = status;
  }
}

/** All client → server calls go through the `/data` dev proxy (Vite strips it,
 *  nginx proxies it in prod). Send/receive cookies for the better-auth session. */
export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`/data${path}`, {
    credentials: 'include',
    ...init,
    headers: {
      ...(init?.body != null ? { 'Content-Type': 'application/json' } : {}),
      ...(init?.headers ?? {}),
    },
  });
  if (!res.ok) {
    let message = `Eroare de rețea (${res.status})`;
    try {
      const parsed = apiErrorSchema.safeParse(await res.json());
      if (parsed.success) message = parsed.data.error;
    } catch { /* non-JSON body → keep the generic message */ }
    throw new ApiClientError(res.status, message);
  }
  // 204/205 carry no body (e.g. DELETE /runs/:id); reading .json() would throw.
  if (res.status === 204 || res.status === 205) return undefined as T;
  return (await res.json()) as T;
}
